var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 37,
    viewBox: "0 0 52 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9219 36.0938C22.375 36.5156 23.7656 35.7344 24.2031 34.2188L32.8281 4.70312C33.2656 3.1875 32.5156 1.79688 31.0625 1.35938C29.6094 0.9375 28.2344 1.73438 27.7812 3.23438L19.1719 32.75C18.7344 34.2656 19.4688 35.6719 20.9219 36.0938ZM39.0469 30.5469L49.8281 20.8125C51.1406 19.6406 51.125 17.8125 49.8281 16.6406L39.0469 6.89062C37.8906 5.84375 36.2812 5.89062 35.2812 7.01562C34.2656 8.15625 34.3594 9.73438 35.5156 10.7812L44.2969 18.7188L35.5156 26.6562C34.3594 27.7031 34.2656 29.2812 35.2812 30.4219C36.2812 31.5469 37.8906 31.5938 39.0469 30.5469ZM12.9375 30.5625C14.1094 31.625 15.7031 31.5625 16.7188 30.4375C17.7344 29.3125 17.625 27.7188 16.4844 26.6719L7.70312 18.75L16.4844 10.8125C17.625 9.76562 17.7344 8.17188 16.7188 7.04688C15.7031 5.92188 14.1094 5.85938 12.9375 6.92188L2.15625 16.6562C0.859375 17.8281 0.859375 19.6562 2.15625 20.8281L12.9375 30.5625Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.4ae5818802b35cdffed358744a3a3fa0.svg";
export { ForwardRef as ReactComponent };